export default "__VITE_ASSET__rwMWMzWa__"